import { Ref, computed, reactive, ComputedRef } from 'vue'
import { NuxeoPageProviderResponse } from '@/contracts/api/ResponseContracts'

// Prepare pagination for nuxeo page provider:
export function pagination(currentPageIndex: Ref, numberOfPaginationPages: number, data: NuxeoPageProviderResponse, grantType?: number)
{
    // Computed vars from data:
    const currentPageNumber = computed(() =>
    {
        return currentPageIndex.value + 1
    })
    const numberOfResults = computed(() =>
    {
        return data.resultsCount
    })
    const numberOfResultsText = computed(() =>
    {
        if(grantType === undefined)
        {
            return '?'
        }
        else if(grantType === 2 && numberOfResults.value === 1)
        {
            return numberOfResults.value + ' document page returned'
        }
        else if(grantType === 2)
        {
            return numberOfResults.value + ' document pages returned'
        }
        else if(numberOfResults.value === 1)
        {
            return numberOfResults.value + ' result returned'
        }
        return numberOfResults.value + ' results returned'
    })
    const isFirstPage = computed(() =>
    {
        return currentPageIndex.value <= 0
    })
    const isLastPage = computed(() =>
    {
        return currentPageIndex.value >= (data.numberOfPages - 1)
    })
    const paginationPages = computed(() =>
    {
        // Hold page numbers to display:
        const pagesArray = []
        // Calculate pages before and after:
        const pagesBefore = Math.floor(numberOfPaginationPages / 2)
        const pagesAfter = (numberOfPaginationPages - 1) - pagesBefore
        // Set start and end pages for array:
        let startPage = currentPageNumber.value - pagesBefore
        let endPage = currentPageNumber.value + pagesAfter
        // Check if start page is legal:
        if(startPage <= 0)
        {
            startPage = 1
        }
        // Check if end page is legal:
        if(endPage > data.pageCount)
        {
            endPage = data.pageCount
        }
        // Loop through values to generate pagination page numbers:
        for(let i = startPage; i <= currentPageNumber.value; i++)
        {
            pagesArray.push(i)
        }
        for(let i = currentPageNumber.value + 1; i <= endPage; i++)
        {
            pagesArray.push(i)
        }
        return pagesArray
    })

    return {
        currentPageNumber,
        numberOfResults,
        numberOfResultsText,
        isFirstPage,
        isLastPage,
        paginationPages
    }
}
